var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"checkbox-wrapper"},[_vm._t("default")],2),_vm._v(" "),(_vm.computedError)?_c('span',{staticClass:"invalid-feedback"},[_c('strong',[_vm._v(_vm._s(_vm.computedError))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }